import { render, staticRenderFns } from "./cuponera.vue?vue&type=template&id=5b91c6e0&scoped=true"
import script from "./cuponera.vue?vue&type=script&lang=js"
export * from "./cuponera.vue?vue&type=script&lang=js"
import style0 from "./cuponera.vue?vue&type=style&index=0&id=5b91c6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91c6e0",
  null
  
)

export default component.exports